/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as SandboxOutcomeRouteImport } from './sandbox-outcome'
import { Route as HandoffRouteImport } from './handoff'
import { Route as CompleteRouteImport } from './complete'
import { Route as OnboardingRouteRouteImport } from './onboarding/route'
import { Route as IdentifyRouteRouteImport } from './identify/route'
import { Route as AuthMethodsRouteRouteImport } from './auth-methods/route'
import { Route as IdentifyIndexRouteImport } from './identify/index'
import { Route as AuthMethodsIndexRouteImport } from './auth-methods/index'
import { Route as WaitForComponentsSdkTokenRouteImport } from './wait-for-components-sdk.$token'
import { Route as IdentifyPhoneRouteImport } from './identify/phone'
import { Route as IdentifyLoginRouteImport } from './identify/login'
import { Route as IdentifyKbaRouteImport } from './identify/kba'
import { Route as IdentifyEmailRouteImport } from './identify/email'
import { Route as AuthMethodsUpdatePhoneRouteImport } from './auth-methods/update-phone'
import { Route as AuthMethodsUpdatePasskeyRouteImport } from './auth-methods/update-passkey'
import { Route as AuthMethodsUpdateEmailRouteImport } from './auth-methods/update-email'
import { Route as OnboardingTokenRouteRouteImport } from './onboarding/$token/route'
import { Route as OnboardingTokenTransferRouteImport } from './onboarding/$token/transfer'
import { Route as OnboardingTokenSelectConditionalBranchRouteImport } from './onboarding/$token/select-conditional-branch'
import { Route as OnboardingTokenRegisterAuthMethodRouteImport } from './onboarding/$token/register-auth-method'
import { Route as OnboardingTokenLivenessRouteImport } from './onboarding/$token/liveness'
import { Route as OnboardingTokenCreateBusinessOnboardingRouteImport } from './onboarding/$token/create-business-onboarding'
import { Route as OnboardingTokenCollectInvestorProfileRouteImport } from './onboarding/$token/collect-investor-profile'
import { Route as OnboardingTokenCollectDocumentRouteImport } from './onboarding/$token/collect-document'
import { Route as OnboardingTokenCollectDataRouteImport } from './onboarding/$token/collect-data'
import { Route as OnboardingTokenCollectCustomDataRouteImport } from './onboarding/$token/collect-custom-data'
import { Route as OnboardingTokenCollectCardDataRouteImport } from './onboarding/$token/collect-card-data'
import { Route as IdentifyOtpChallengeKindRouteImport } from './identify/otp.$challengeKind'
import { Route as OnboardingTokenCollectBusinessDataRouteRouteImport } from './onboarding/$token/collect-business-data/route'
import { Route as OnboardingTokenCollectBusinessDataBusinessOwnersRouteImport } from './onboarding/$token/collect-business-data/business-owners'
import { Route as OnboardingTokenCollectBusinessDataBusinessInformationRouteImport } from './onboarding/$token/collect-business-data/business-information'

const SandboxOutcomeRoute = SandboxOutcomeRouteImport.update({
  id: '/sandbox-outcome',
  path: '/sandbox-outcome',
  getParentRoute: () => rootRouteImport,
} as any)
const HandoffRoute = HandoffRouteImport.update({
  id: '/handoff',
  path: '/handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteRoute = CompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentifyRouteRoute = IdentifyRouteRouteImport.update({
  id: '/identify',
  path: '/identify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMethodsRouteRoute = AuthMethodsRouteRouteImport.update({
  id: '/auth-methods',
  path: '/auth-methods',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentifyIndexRoute = IdentifyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IdentifyRouteRoute,
} as any)
const AuthMethodsIndexRoute = AuthMethodsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMethodsRouteRoute,
} as any)
const WaitForComponentsSdkTokenRoute =
  WaitForComponentsSdkTokenRouteImport.update({
    id: '/wait-for-components-sdk/$token',
    path: '/wait-for-components-sdk/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const IdentifyPhoneRoute = IdentifyPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => IdentifyRouteRoute,
} as any)
const IdentifyLoginRoute = IdentifyLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => IdentifyRouteRoute,
} as any)
const IdentifyKbaRoute = IdentifyKbaRouteImport.update({
  id: '/kba',
  path: '/kba',
  getParentRoute: () => IdentifyRouteRoute,
} as any)
const IdentifyEmailRoute = IdentifyEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => IdentifyRouteRoute,
} as any)
const AuthMethodsUpdatePhoneRoute = AuthMethodsUpdatePhoneRouteImport.update({
  id: '/update-phone',
  path: '/update-phone',
  getParentRoute: () => AuthMethodsRouteRoute,
} as any)
const AuthMethodsUpdatePasskeyRoute =
  AuthMethodsUpdatePasskeyRouteImport.update({
    id: '/update-passkey',
    path: '/update-passkey',
    getParentRoute: () => AuthMethodsRouteRoute,
  } as any)
const AuthMethodsUpdateEmailRoute = AuthMethodsUpdateEmailRouteImport.update({
  id: '/update-email',
  path: '/update-email',
  getParentRoute: () => AuthMethodsRouteRoute,
} as any)
const OnboardingTokenRouteRoute = OnboardingTokenRouteRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingTokenTransferRoute = OnboardingTokenTransferRouteImport.update({
  id: '/transfer',
  path: '/transfer',
  getParentRoute: () => OnboardingTokenRouteRoute,
} as any)
const OnboardingTokenSelectConditionalBranchRoute =
  OnboardingTokenSelectConditionalBranchRouteImport.update({
    id: '/select-conditional-branch',
    path: '/select-conditional-branch',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenRegisterAuthMethodRoute =
  OnboardingTokenRegisterAuthMethodRouteImport.update({
    id: '/register-auth-method',
    path: '/register-auth-method',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenLivenessRoute = OnboardingTokenLivenessRouteImport.update({
  id: '/liveness',
  path: '/liveness',
  getParentRoute: () => OnboardingTokenRouteRoute,
} as any)
const OnboardingTokenCreateBusinessOnboardingRoute =
  OnboardingTokenCreateBusinessOnboardingRouteImport.update({
    id: '/create-business-onboarding',
    path: '/create-business-onboarding',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectInvestorProfileRoute =
  OnboardingTokenCollectInvestorProfileRouteImport.update({
    id: '/collect-investor-profile',
    path: '/collect-investor-profile',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectDocumentRoute =
  OnboardingTokenCollectDocumentRouteImport.update({
    id: '/collect-document',
    path: '/collect-document',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectDataRoute =
  OnboardingTokenCollectDataRouteImport.update({
    id: '/collect-data',
    path: '/collect-data',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectCustomDataRoute =
  OnboardingTokenCollectCustomDataRouteImport.update({
    id: '/collect-custom-data',
    path: '/collect-custom-data',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectCardDataRoute =
  OnboardingTokenCollectCardDataRouteImport.update({
    id: '/collect-card-data',
    path: '/collect-card-data',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const IdentifyOtpChallengeKindRoute =
  IdentifyOtpChallengeKindRouteImport.update({
    id: '/otp/$challengeKind',
    path: '/otp/$challengeKind',
    getParentRoute: () => IdentifyRouteRoute,
  } as any)
const OnboardingTokenCollectBusinessDataRouteRoute =
  OnboardingTokenCollectBusinessDataRouteRouteImport.update({
    id: '/collect-business-data',
    path: '/collect-business-data',
    getParentRoute: () => OnboardingTokenRouteRoute,
  } as any)
const OnboardingTokenCollectBusinessDataBusinessOwnersRoute =
  OnboardingTokenCollectBusinessDataBusinessOwnersRouteImport.update({
    id: '/business-owners',
    path: '/business-owners',
    getParentRoute: () => OnboardingTokenCollectBusinessDataRouteRoute,
  } as any)
const OnboardingTokenCollectBusinessDataBusinessInformationRoute =
  OnboardingTokenCollectBusinessDataBusinessInformationRouteImport.update({
    id: '/business-information',
    path: '/business-information',
    getParentRoute: () => OnboardingTokenCollectBusinessDataRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth-methods': typeof AuthMethodsRouteRouteWithChildren
  '/identify': typeof IdentifyRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/complete': typeof CompleteRoute
  '/handoff': typeof HandoffRoute
  '/sandbox-outcome': typeof SandboxOutcomeRoute
  '/onboarding/$token': typeof OnboardingTokenRouteRouteWithChildren
  '/auth-methods/update-email': typeof AuthMethodsUpdateEmailRoute
  '/auth-methods/update-passkey': typeof AuthMethodsUpdatePasskeyRoute
  '/auth-methods/update-phone': typeof AuthMethodsUpdatePhoneRoute
  '/identify/email': typeof IdentifyEmailRoute
  '/identify/kba': typeof IdentifyKbaRoute
  '/identify/login': typeof IdentifyLoginRoute
  '/identify/phone': typeof IdentifyPhoneRoute
  '/wait-for-components-sdk/$token': typeof WaitForComponentsSdkTokenRoute
  '/auth-methods/': typeof AuthMethodsIndexRoute
  '/identify/': typeof IdentifyIndexRoute
  '/onboarding/$token/collect-business-data': typeof OnboardingTokenCollectBusinessDataRouteRouteWithChildren
  '/identify/otp/$challengeKind': typeof IdentifyOtpChallengeKindRoute
  '/onboarding/$token/collect-card-data': typeof OnboardingTokenCollectCardDataRoute
  '/onboarding/$token/collect-custom-data': typeof OnboardingTokenCollectCustomDataRoute
  '/onboarding/$token/collect-data': typeof OnboardingTokenCollectDataRoute
  '/onboarding/$token/collect-document': typeof OnboardingTokenCollectDocumentRoute
  '/onboarding/$token/collect-investor-profile': typeof OnboardingTokenCollectInvestorProfileRoute
  '/onboarding/$token/create-business-onboarding': typeof OnboardingTokenCreateBusinessOnboardingRoute
  '/onboarding/$token/liveness': typeof OnboardingTokenLivenessRoute
  '/onboarding/$token/register-auth-method': typeof OnboardingTokenRegisterAuthMethodRoute
  '/onboarding/$token/select-conditional-branch': typeof OnboardingTokenSelectConditionalBranchRoute
  '/onboarding/$token/transfer': typeof OnboardingTokenTransferRoute
  '/onboarding/$token/collect-business-data/business-information': typeof OnboardingTokenCollectBusinessDataBusinessInformationRoute
  '/onboarding/$token/collect-business-data/business-owners': typeof OnboardingTokenCollectBusinessDataBusinessOwnersRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/complete': typeof CompleteRoute
  '/handoff': typeof HandoffRoute
  '/sandbox-outcome': typeof SandboxOutcomeRoute
  '/onboarding/$token': typeof OnboardingTokenRouteRouteWithChildren
  '/auth-methods/update-email': typeof AuthMethodsUpdateEmailRoute
  '/auth-methods/update-passkey': typeof AuthMethodsUpdatePasskeyRoute
  '/auth-methods/update-phone': typeof AuthMethodsUpdatePhoneRoute
  '/identify/email': typeof IdentifyEmailRoute
  '/identify/kba': typeof IdentifyKbaRoute
  '/identify/login': typeof IdentifyLoginRoute
  '/identify/phone': typeof IdentifyPhoneRoute
  '/wait-for-components-sdk/$token': typeof WaitForComponentsSdkTokenRoute
  '/auth-methods': typeof AuthMethodsIndexRoute
  '/identify': typeof IdentifyIndexRoute
  '/onboarding/$token/collect-business-data': typeof OnboardingTokenCollectBusinessDataRouteRouteWithChildren
  '/identify/otp/$challengeKind': typeof IdentifyOtpChallengeKindRoute
  '/onboarding/$token/collect-card-data': typeof OnboardingTokenCollectCardDataRoute
  '/onboarding/$token/collect-custom-data': typeof OnboardingTokenCollectCustomDataRoute
  '/onboarding/$token/collect-data': typeof OnboardingTokenCollectDataRoute
  '/onboarding/$token/collect-document': typeof OnboardingTokenCollectDocumentRoute
  '/onboarding/$token/collect-investor-profile': typeof OnboardingTokenCollectInvestorProfileRoute
  '/onboarding/$token/create-business-onboarding': typeof OnboardingTokenCreateBusinessOnboardingRoute
  '/onboarding/$token/liveness': typeof OnboardingTokenLivenessRoute
  '/onboarding/$token/register-auth-method': typeof OnboardingTokenRegisterAuthMethodRoute
  '/onboarding/$token/select-conditional-branch': typeof OnboardingTokenSelectConditionalBranchRoute
  '/onboarding/$token/transfer': typeof OnboardingTokenTransferRoute
  '/onboarding/$token/collect-business-data/business-information': typeof OnboardingTokenCollectBusinessDataBusinessInformationRoute
  '/onboarding/$token/collect-business-data/business-owners': typeof OnboardingTokenCollectBusinessDataBusinessOwnersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/auth-methods': typeof AuthMethodsRouteRouteWithChildren
  '/identify': typeof IdentifyRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/complete': typeof CompleteRoute
  '/handoff': typeof HandoffRoute
  '/sandbox-outcome': typeof SandboxOutcomeRoute
  '/onboarding/$token': typeof OnboardingTokenRouteRouteWithChildren
  '/auth-methods/update-email': typeof AuthMethodsUpdateEmailRoute
  '/auth-methods/update-passkey': typeof AuthMethodsUpdatePasskeyRoute
  '/auth-methods/update-phone': typeof AuthMethodsUpdatePhoneRoute
  '/identify/email': typeof IdentifyEmailRoute
  '/identify/kba': typeof IdentifyKbaRoute
  '/identify/login': typeof IdentifyLoginRoute
  '/identify/phone': typeof IdentifyPhoneRoute
  '/wait-for-components-sdk/$token': typeof WaitForComponentsSdkTokenRoute
  '/auth-methods/': typeof AuthMethodsIndexRoute
  '/identify/': typeof IdentifyIndexRoute
  '/onboarding/$token/collect-business-data': typeof OnboardingTokenCollectBusinessDataRouteRouteWithChildren
  '/identify/otp/$challengeKind': typeof IdentifyOtpChallengeKindRoute
  '/onboarding/$token/collect-card-data': typeof OnboardingTokenCollectCardDataRoute
  '/onboarding/$token/collect-custom-data': typeof OnboardingTokenCollectCustomDataRoute
  '/onboarding/$token/collect-data': typeof OnboardingTokenCollectDataRoute
  '/onboarding/$token/collect-document': typeof OnboardingTokenCollectDocumentRoute
  '/onboarding/$token/collect-investor-profile': typeof OnboardingTokenCollectInvestorProfileRoute
  '/onboarding/$token/create-business-onboarding': typeof OnboardingTokenCreateBusinessOnboardingRoute
  '/onboarding/$token/liveness': typeof OnboardingTokenLivenessRoute
  '/onboarding/$token/register-auth-method': typeof OnboardingTokenRegisterAuthMethodRoute
  '/onboarding/$token/select-conditional-branch': typeof OnboardingTokenSelectConditionalBranchRoute
  '/onboarding/$token/transfer': typeof OnboardingTokenTransferRoute
  '/onboarding/$token/collect-business-data/business-information': typeof OnboardingTokenCollectBusinessDataBusinessInformationRoute
  '/onboarding/$token/collect-business-data/business-owners': typeof OnboardingTokenCollectBusinessDataBusinessOwnersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth-methods'
    | '/identify'
    | '/onboarding'
    | '/complete'
    | '/handoff'
    | '/sandbox-outcome'
    | '/onboarding/$token'
    | '/auth-methods/update-email'
    | '/auth-methods/update-passkey'
    | '/auth-methods/update-phone'
    | '/identify/email'
    | '/identify/kba'
    | '/identify/login'
    | '/identify/phone'
    | '/wait-for-components-sdk/$token'
    | '/auth-methods/'
    | '/identify/'
    | '/onboarding/$token/collect-business-data'
    | '/identify/otp/$challengeKind'
    | '/onboarding/$token/collect-card-data'
    | '/onboarding/$token/collect-custom-data'
    | '/onboarding/$token/collect-data'
    | '/onboarding/$token/collect-document'
    | '/onboarding/$token/collect-investor-profile'
    | '/onboarding/$token/create-business-onboarding'
    | '/onboarding/$token/liveness'
    | '/onboarding/$token/register-auth-method'
    | '/onboarding/$token/select-conditional-branch'
    | '/onboarding/$token/transfer'
    | '/onboarding/$token/collect-business-data/business-information'
    | '/onboarding/$token/collect-business-data/business-owners'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/complete'
    | '/handoff'
    | '/sandbox-outcome'
    | '/onboarding/$token'
    | '/auth-methods/update-email'
    | '/auth-methods/update-passkey'
    | '/auth-methods/update-phone'
    | '/identify/email'
    | '/identify/kba'
    | '/identify/login'
    | '/identify/phone'
    | '/wait-for-components-sdk/$token'
    | '/auth-methods'
    | '/identify'
    | '/onboarding/$token/collect-business-data'
    | '/identify/otp/$challengeKind'
    | '/onboarding/$token/collect-card-data'
    | '/onboarding/$token/collect-custom-data'
    | '/onboarding/$token/collect-data'
    | '/onboarding/$token/collect-document'
    | '/onboarding/$token/collect-investor-profile'
    | '/onboarding/$token/create-business-onboarding'
    | '/onboarding/$token/liveness'
    | '/onboarding/$token/register-auth-method'
    | '/onboarding/$token/select-conditional-branch'
    | '/onboarding/$token/transfer'
    | '/onboarding/$token/collect-business-data/business-information'
    | '/onboarding/$token/collect-business-data/business-owners'
  id:
    | '__root__'
    | '/auth-methods'
    | '/identify'
    | '/onboarding'
    | '/complete'
    | '/handoff'
    | '/sandbox-outcome'
    | '/onboarding/$token'
    | '/auth-methods/update-email'
    | '/auth-methods/update-passkey'
    | '/auth-methods/update-phone'
    | '/identify/email'
    | '/identify/kba'
    | '/identify/login'
    | '/identify/phone'
    | '/wait-for-components-sdk/$token'
    | '/auth-methods/'
    | '/identify/'
    | '/onboarding/$token/collect-business-data'
    | '/identify/otp/$challengeKind'
    | '/onboarding/$token/collect-card-data'
    | '/onboarding/$token/collect-custom-data'
    | '/onboarding/$token/collect-data'
    | '/onboarding/$token/collect-document'
    | '/onboarding/$token/collect-investor-profile'
    | '/onboarding/$token/create-business-onboarding'
    | '/onboarding/$token/liveness'
    | '/onboarding/$token/register-auth-method'
    | '/onboarding/$token/select-conditional-branch'
    | '/onboarding/$token/transfer'
    | '/onboarding/$token/collect-business-data/business-information'
    | '/onboarding/$token/collect-business-data/business-owners'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthMethodsRouteRoute: typeof AuthMethodsRouteRouteWithChildren
  IdentifyRouteRoute: typeof IdentifyRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  CompleteRoute: typeof CompleteRoute
  HandoffRoute: typeof HandoffRoute
  SandboxOutcomeRoute: typeof SandboxOutcomeRoute
  WaitForComponentsSdkTokenRoute: typeof WaitForComponentsSdkTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sandbox-outcome': {
      id: '/sandbox-outcome'
      path: '/sandbox-outcome'
      fullPath: '/sandbox-outcome'
      preLoaderRoute: typeof SandboxOutcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/handoff': {
      id: '/handoff'
      path: '/handoff'
      fullPath: '/handoff'
      preLoaderRoute: typeof HandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete': {
      id: '/complete'
      path: '/complete'
      fullPath: '/complete'
      preLoaderRoute: typeof CompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identify': {
      id: '/identify'
      path: '/identify'
      fullPath: '/identify'
      preLoaderRoute: typeof IdentifyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-methods': {
      id: '/auth-methods'
      path: '/auth-methods'
      fullPath: '/auth-methods'
      preLoaderRoute: typeof AuthMethodsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identify/': {
      id: '/identify/'
      path: '/'
      fullPath: '/identify/'
      preLoaderRoute: typeof IdentifyIndexRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/auth-methods/': {
      id: '/auth-methods/'
      path: '/'
      fullPath: '/auth-methods/'
      preLoaderRoute: typeof AuthMethodsIndexRouteImport
      parentRoute: typeof AuthMethodsRouteRoute
    }
    '/wait-for-components-sdk/$token': {
      id: '/wait-for-components-sdk/$token'
      path: '/wait-for-components-sdk/$token'
      fullPath: '/wait-for-components-sdk/$token'
      preLoaderRoute: typeof WaitForComponentsSdkTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identify/phone': {
      id: '/identify/phone'
      path: '/phone'
      fullPath: '/identify/phone'
      preLoaderRoute: typeof IdentifyPhoneRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/identify/login': {
      id: '/identify/login'
      path: '/login'
      fullPath: '/identify/login'
      preLoaderRoute: typeof IdentifyLoginRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/identify/kba': {
      id: '/identify/kba'
      path: '/kba'
      fullPath: '/identify/kba'
      preLoaderRoute: typeof IdentifyKbaRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/identify/email': {
      id: '/identify/email'
      path: '/email'
      fullPath: '/identify/email'
      preLoaderRoute: typeof IdentifyEmailRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/auth-methods/update-phone': {
      id: '/auth-methods/update-phone'
      path: '/update-phone'
      fullPath: '/auth-methods/update-phone'
      preLoaderRoute: typeof AuthMethodsUpdatePhoneRouteImport
      parentRoute: typeof AuthMethodsRouteRoute
    }
    '/auth-methods/update-passkey': {
      id: '/auth-methods/update-passkey'
      path: '/update-passkey'
      fullPath: '/auth-methods/update-passkey'
      preLoaderRoute: typeof AuthMethodsUpdatePasskeyRouteImport
      parentRoute: typeof AuthMethodsRouteRoute
    }
    '/auth-methods/update-email': {
      id: '/auth-methods/update-email'
      path: '/update-email'
      fullPath: '/auth-methods/update-email'
      preLoaderRoute: typeof AuthMethodsUpdateEmailRouteImport
      parentRoute: typeof AuthMethodsRouteRoute
    }
    '/onboarding/$token': {
      id: '/onboarding/$token'
      path: '/$token'
      fullPath: '/onboarding/$token'
      preLoaderRoute: typeof OnboardingTokenRouteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/$token/transfer': {
      id: '/onboarding/$token/transfer'
      path: '/transfer'
      fullPath: '/onboarding/$token/transfer'
      preLoaderRoute: typeof OnboardingTokenTransferRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/select-conditional-branch': {
      id: '/onboarding/$token/select-conditional-branch'
      path: '/select-conditional-branch'
      fullPath: '/onboarding/$token/select-conditional-branch'
      preLoaderRoute: typeof OnboardingTokenSelectConditionalBranchRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/register-auth-method': {
      id: '/onboarding/$token/register-auth-method'
      path: '/register-auth-method'
      fullPath: '/onboarding/$token/register-auth-method'
      preLoaderRoute: typeof OnboardingTokenRegisterAuthMethodRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/liveness': {
      id: '/onboarding/$token/liveness'
      path: '/liveness'
      fullPath: '/onboarding/$token/liveness'
      preLoaderRoute: typeof OnboardingTokenLivenessRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/create-business-onboarding': {
      id: '/onboarding/$token/create-business-onboarding'
      path: '/create-business-onboarding'
      fullPath: '/onboarding/$token/create-business-onboarding'
      preLoaderRoute: typeof OnboardingTokenCreateBusinessOnboardingRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-investor-profile': {
      id: '/onboarding/$token/collect-investor-profile'
      path: '/collect-investor-profile'
      fullPath: '/onboarding/$token/collect-investor-profile'
      preLoaderRoute: typeof OnboardingTokenCollectInvestorProfileRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-document': {
      id: '/onboarding/$token/collect-document'
      path: '/collect-document'
      fullPath: '/onboarding/$token/collect-document'
      preLoaderRoute: typeof OnboardingTokenCollectDocumentRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-data': {
      id: '/onboarding/$token/collect-data'
      path: '/collect-data'
      fullPath: '/onboarding/$token/collect-data'
      preLoaderRoute: typeof OnboardingTokenCollectDataRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-custom-data': {
      id: '/onboarding/$token/collect-custom-data'
      path: '/collect-custom-data'
      fullPath: '/onboarding/$token/collect-custom-data'
      preLoaderRoute: typeof OnboardingTokenCollectCustomDataRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-card-data': {
      id: '/onboarding/$token/collect-card-data'
      path: '/collect-card-data'
      fullPath: '/onboarding/$token/collect-card-data'
      preLoaderRoute: typeof OnboardingTokenCollectCardDataRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/identify/otp/$challengeKind': {
      id: '/identify/otp/$challengeKind'
      path: '/otp/$challengeKind'
      fullPath: '/identify/otp/$challengeKind'
      preLoaderRoute: typeof IdentifyOtpChallengeKindRouteImport
      parentRoute: typeof IdentifyRouteRoute
    }
    '/onboarding/$token/collect-business-data': {
      id: '/onboarding/$token/collect-business-data'
      path: '/collect-business-data'
      fullPath: '/onboarding/$token/collect-business-data'
      preLoaderRoute: typeof OnboardingTokenCollectBusinessDataRouteRouteImport
      parentRoute: typeof OnboardingTokenRouteRoute
    }
    '/onboarding/$token/collect-business-data/business-owners': {
      id: '/onboarding/$token/collect-business-data/business-owners'
      path: '/business-owners'
      fullPath: '/onboarding/$token/collect-business-data/business-owners'
      preLoaderRoute: typeof OnboardingTokenCollectBusinessDataBusinessOwnersRouteImport
      parentRoute: typeof OnboardingTokenCollectBusinessDataRouteRoute
    }
    '/onboarding/$token/collect-business-data/business-information': {
      id: '/onboarding/$token/collect-business-data/business-information'
      path: '/business-information'
      fullPath: '/onboarding/$token/collect-business-data/business-information'
      preLoaderRoute: typeof OnboardingTokenCollectBusinessDataBusinessInformationRouteImport
      parentRoute: typeof OnboardingTokenCollectBusinessDataRouteRoute
    }
  }
}

interface AuthMethodsRouteRouteChildren {
  AuthMethodsUpdateEmailRoute: typeof AuthMethodsUpdateEmailRoute
  AuthMethodsUpdatePasskeyRoute: typeof AuthMethodsUpdatePasskeyRoute
  AuthMethodsUpdatePhoneRoute: typeof AuthMethodsUpdatePhoneRoute
  AuthMethodsIndexRoute: typeof AuthMethodsIndexRoute
}

const AuthMethodsRouteRouteChildren: AuthMethodsRouteRouteChildren = {
  AuthMethodsUpdateEmailRoute: AuthMethodsUpdateEmailRoute,
  AuthMethodsUpdatePasskeyRoute: AuthMethodsUpdatePasskeyRoute,
  AuthMethodsUpdatePhoneRoute: AuthMethodsUpdatePhoneRoute,
  AuthMethodsIndexRoute: AuthMethodsIndexRoute,
}

const AuthMethodsRouteRouteWithChildren =
  AuthMethodsRouteRoute._addFileChildren(AuthMethodsRouteRouteChildren)

interface IdentifyRouteRouteChildren {
  IdentifyEmailRoute: typeof IdentifyEmailRoute
  IdentifyKbaRoute: typeof IdentifyKbaRoute
  IdentifyLoginRoute: typeof IdentifyLoginRoute
  IdentifyPhoneRoute: typeof IdentifyPhoneRoute
  IdentifyIndexRoute: typeof IdentifyIndexRoute
  IdentifyOtpChallengeKindRoute: typeof IdentifyOtpChallengeKindRoute
}

const IdentifyRouteRouteChildren: IdentifyRouteRouteChildren = {
  IdentifyEmailRoute: IdentifyEmailRoute,
  IdentifyKbaRoute: IdentifyKbaRoute,
  IdentifyLoginRoute: IdentifyLoginRoute,
  IdentifyPhoneRoute: IdentifyPhoneRoute,
  IdentifyIndexRoute: IdentifyIndexRoute,
  IdentifyOtpChallengeKindRoute: IdentifyOtpChallengeKindRoute,
}

const IdentifyRouteRouteWithChildren = IdentifyRouteRoute._addFileChildren(
  IdentifyRouteRouteChildren,
)

interface OnboardingTokenCollectBusinessDataRouteRouteChildren {
  OnboardingTokenCollectBusinessDataBusinessInformationRoute: typeof OnboardingTokenCollectBusinessDataBusinessInformationRoute
  OnboardingTokenCollectBusinessDataBusinessOwnersRoute: typeof OnboardingTokenCollectBusinessDataBusinessOwnersRoute
}

const OnboardingTokenCollectBusinessDataRouteRouteChildren: OnboardingTokenCollectBusinessDataRouteRouteChildren =
  {
    OnboardingTokenCollectBusinessDataBusinessInformationRoute:
      OnboardingTokenCollectBusinessDataBusinessInformationRoute,
    OnboardingTokenCollectBusinessDataBusinessOwnersRoute:
      OnboardingTokenCollectBusinessDataBusinessOwnersRoute,
  }

const OnboardingTokenCollectBusinessDataRouteRouteWithChildren =
  OnboardingTokenCollectBusinessDataRouteRoute._addFileChildren(
    OnboardingTokenCollectBusinessDataRouteRouteChildren,
  )

interface OnboardingTokenRouteRouteChildren {
  OnboardingTokenCollectBusinessDataRouteRoute: typeof OnboardingTokenCollectBusinessDataRouteRouteWithChildren
  OnboardingTokenCollectCardDataRoute: typeof OnboardingTokenCollectCardDataRoute
  OnboardingTokenCollectCustomDataRoute: typeof OnboardingTokenCollectCustomDataRoute
  OnboardingTokenCollectDataRoute: typeof OnboardingTokenCollectDataRoute
  OnboardingTokenCollectDocumentRoute: typeof OnboardingTokenCollectDocumentRoute
  OnboardingTokenCollectInvestorProfileRoute: typeof OnboardingTokenCollectInvestorProfileRoute
  OnboardingTokenCreateBusinessOnboardingRoute: typeof OnboardingTokenCreateBusinessOnboardingRoute
  OnboardingTokenLivenessRoute: typeof OnboardingTokenLivenessRoute
  OnboardingTokenRegisterAuthMethodRoute: typeof OnboardingTokenRegisterAuthMethodRoute
  OnboardingTokenSelectConditionalBranchRoute: typeof OnboardingTokenSelectConditionalBranchRoute
  OnboardingTokenTransferRoute: typeof OnboardingTokenTransferRoute
}

const OnboardingTokenRouteRouteChildren: OnboardingTokenRouteRouteChildren = {
  OnboardingTokenCollectBusinessDataRouteRoute:
    OnboardingTokenCollectBusinessDataRouteRouteWithChildren,
  OnboardingTokenCollectCardDataRoute: OnboardingTokenCollectCardDataRoute,
  OnboardingTokenCollectCustomDataRoute: OnboardingTokenCollectCustomDataRoute,
  OnboardingTokenCollectDataRoute: OnboardingTokenCollectDataRoute,
  OnboardingTokenCollectDocumentRoute: OnboardingTokenCollectDocumentRoute,
  OnboardingTokenCollectInvestorProfileRoute:
    OnboardingTokenCollectInvestorProfileRoute,
  OnboardingTokenCreateBusinessOnboardingRoute:
    OnboardingTokenCreateBusinessOnboardingRoute,
  OnboardingTokenLivenessRoute: OnboardingTokenLivenessRoute,
  OnboardingTokenRegisterAuthMethodRoute:
    OnboardingTokenRegisterAuthMethodRoute,
  OnboardingTokenSelectConditionalBranchRoute:
    OnboardingTokenSelectConditionalBranchRoute,
  OnboardingTokenTransferRoute: OnboardingTokenTransferRoute,
}

const OnboardingTokenRouteRouteWithChildren =
  OnboardingTokenRouteRoute._addFileChildren(OnboardingTokenRouteRouteChildren)

interface OnboardingRouteRouteChildren {
  OnboardingTokenRouteRoute: typeof OnboardingTokenRouteRouteWithChildren
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingTokenRouteRoute: OnboardingTokenRouteRouteWithChildren,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthMethodsRouteRoute: AuthMethodsRouteRouteWithChildren,
  IdentifyRouteRoute: IdentifyRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  CompleteRoute: CompleteRoute,
  HandoffRoute: HandoffRoute,
  SandboxOutcomeRoute: SandboxOutcomeRoute,
  WaitForComponentsSdkTokenRoute: WaitForComponentsSdkTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
